import React from 'react'
import { titleBlue, titleGrey, paragraphGrey, linkGreen } from '../../colors';
import {Link} from 'react-router-dom'

const styles = {
    title: {
        fontSize: '36px',
        marginBottom: '50px',
        color: titleBlue,
        fontWeight:700

    },
    subTitle: {
        fontSize: '16px',
        marginBottom: '10px',
        color: titleGrey
    },
    paragraph: {
        fontSize: '12px',
        color: paragraphGrey,
        marginBottom: '15px',
        lineHeight:2
    },
    hint:{
        fontSize:'10px'
    },
    section:{
        marginTop:'100px',
       // borderBottom:'1px solid #f6f2f2'
    },
    subSection:{
        padding:'40px 15px'
    },
    subSectionAction:{
        color:linkGreen
    }
}
export const Typography = ({ children, style, variant, align,color }) => {
    return ['paragraph','hint'].indexOf(variant) === -1  ?
        (
            <h1 style={{ ...styles[variant], ...style, textAlign: align,color:color?color:'inherit' }}>{children}</h1>
        )
        :
        (
            <p style={{ ...styles[variant], ...style, textAlign: align,color:color?color:'inherit' }}>{children}</p>
        )
}
export const SubSection = ({ children }) => {
    return (
        <div style={{...styles.subSection}}>
            {children}
        </div>
    )
}
export const SubSectionAction = ({children,to,color,style, ...props }) => {
    return (
        <Link style={{...style,color:color?color:linkGreen}} to={to}>
            {children}
        </Link>
    )
}
export const Section = ({style,children})=>{
    return(
        <div style={{...styles.section,...style}}>
            {children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/products/partials.jsx